import { render } from "./DecorationSetDetailPage.vue?vue&type=template&id=7cb25342&scoped=true"
import script from "./DecorationSetDetailPage.vue?vue&type=script&lang=js"
export * from "./DecorationSetDetailPage.vue?vue&type=script&lang=js"

import "./DecorationSetDetailPage.vue?vue&type=style&index=0&id=7cb25342&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7cb25342"]])

export default __exports__